
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/profile",
      function () {
        return require("private-next-pages/settings/profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/profile"])
      });
    }
  